// extracted by mini-css-extract-plugin
export default {"notification-div":"notifications_notification-div__xtLQO","notifications-no-data":"notifications_notifications-no-data__4gDgH"};